<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-05-21 16:02:42
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-07-10 18:03:25
 * @FilePath: \qctsw-vue\packages\app\src\components\Basic\CheckBoxGroup.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
const props = withDefaults(defineProps<{
  modelValue?: (string | number)[]
  options?: {
    label: string
    value: string | number
  }[] | Readonly<{ label: string, value: string | number }[]>
}>(), {
  modelValue: () => [],
})

const emits = defineEmits({
  'update:modelValue': (_value?: (string | number)[]) => true,
})

function clickHandle(value: string | number) {
  const index = props.modelValue?.indexOf(value)
  if (index === -1) {
    emits('update:modelValue', [...props.modelValue, value])
  }
  else {
    const arr = [...props.modelValue]
    arr.splice(index, 1)
    emits('update:modelValue', arr)
  }
}
</script>

<template>
  <div class="flex items-center flex-wrap ">
    <button
      v-for="v in props.options" :key="v.value"
      class="px-sm py-1 my-2 text-3.5 rounded-md border-1 border-slate-3 mr-2"
      :class="[props.modelValue?.includes((v.value)) ? 'bg-blue-5 text-white' : 'bg-white text-slate-6']"
      @click="clickHandle(
        (v.value))"
    >
      {{ v.label }}
    </button>
  </div>
</template>

<style lang='scss' scoped>

</style>
